import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import vuetify from './plugins/vuetify';
import VueRouter from 'vue-router'
import Mails from './views/Mails'
import Dashboard from './views/Dashboard'

Vue.config.productionTip = false

Vue.use(VueAxios, axios)
Vue.use(VueRouter)

const routes = [
  { path: '/', component: Dashboard },
  { path: '/mails', component: Mails }
]

const router = new VueRouter({
  routes // short for `routes: routes`
})


new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
